import { type Reducer } from 'redux';

import { type updateTeacherAVState, ACTIONS } from '@~/actions/live-class-config';

interface LiveClassConfigState {
  [teacherClassroomId: string]: {
    cameraErroredTime?: number;
    cameraUnavailable?: boolean;
    canEnterWithoutCamera?: boolean;
    teacherAVState?: {
      activeStudentId?: string;
      onHold: boolean;
      onMute: boolean;
    };
  };
}

const initialState: LiveClassConfigState = {};

type LiveClassConfigReducer = Reducer<
  LiveClassConfigState,
  ReturnType<typeof updateTeacherAVState>
>;

const liveClassConfigReducer: LiveClassConfigReducer = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === ACTIONS.UPDATE_TEACHER_AV_STATE) {
    const { teacherClassroomId, ...avState } = payload;

    return {
      [teacherClassroomId]: {
        ...state[teacherClassroomId],
        teacherAVState: avState,
      },
    };
  }

  return state;
};

export default liveClassConfigReducer;
